import { RECURRENCE_PRESETS } from './constants'

const toPairs = items => items.map(item => [item.name, item.id])

export const userToSelectOption = user => ({
  value: user.id,
  label: `${user.last_name} ${user.first_name}`
})

export const sectionToSelectOption = section => ({
  value: section.id,
  label: section.name
})

const groupOperatorsForSelect = operators => Object.entries(operators || {}).map(([role, users]) => ({
  label: role,
  options: users.map(userToSelectOption)
}))

const sortPairsByLabel = (first, second) => first[0].localeCompare(second[0])

const textVariables = variables => variables.filter(variable => variable.variable_type === 'text')

const buildFormOptions = ({ collect, summaryOptions }) => ({
  users: groupOperatorsForSelect(collect.operators),
  sections: collect.sections.map(section => [section.name, section.id]),
  generators: summaryOptions.generators,
  credentials: summaryOptions.credentials || [],
  variables: toPairs(textVariables(collect.variables)).sort(sortPairsByLabel),
  recurrencePresets: RECURRENCE_PRESETS,
  collectFrequency: collect.frequency,
  channels: summaryOptions.channels
})

export default buildFormOptions
